/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */
// import * as Sentry from '@sentry/vue';
import firebase from 'firebase/compat/app';
import 'firebase/compat/analytics';

const firebaseConfig = {
  apiKey: 'AIzaSyBUbWRv1ZTPYeCPOhZqVnN0LI7czTW61kc',
  authDomain: 'links.app.smilekiosk.gr',
  projectId: 'loyalty-app-322410',
  storageBucket: 'loyalty-app-322410.appspot.com',
  messagingSenderId: '495939166011',
  appId: '1:495939166011:web:0f50e599499bd85cb7211e',
  measurementId: 'G-7V0K1LHLTN',
};

const state = () => ({
  analyticsInstance: null,
});

// getters
const getters = {
};

  // actions
const actions = {
  init({ commit, rootGetters }) {
    if (!rootGetters['device/isProduction']) return;

    if (rootGetters['device/isBrowser']) {
      // Initialize Firebase
      firebase.initializeApp(firebaseConfig);
      // Initialize Analytics and get a reference to the service
      commit('setFirebaseAnalyticsInstance', firebase.analytics());
    }
  },
  setUser({ state, rootGetters, rootState }, { userId }) {
    if (!rootGetters['device/isProduction']) return;

    if (rootGetters['device/isBrowser']) {
      state.analyticsInstance.setUserId(userId);
    } else {
      rootState.firebase.firebasePlugin.setUserId(userId);
    }
  },
  setScreenView({ state, rootGetters, rootState }, { page }) {
    if (!rootGetters['device/isProduction']) return;

    if (rootGetters['device/isBrowser']) {
      state.analyticsInstance.logEvent('screen_view', {
        firebase_screen: page,
      });
    } else {
      rootState.firebase.firebasePlugin.setScreenName(page);
    }
  },
  setLogin({ state, rootGetters, rootState }, { method }) {
    if (!rootGetters['device/isProduction']) return;

    if (rootGetters['device/isBrowser']) {
      state.analyticsInstance.logEvent('login', {
        method,
      });
    } else {
      rootState.firebase.firebasePlugin.logEvent('login', {
        method,
      });
    }
  },
  setPromotion(
    { state, rootGetters, rootState },
    { creativeName, creativeSlot, contestId, contestName },
  ) {
    if (!rootGetters['device/isProduction']) return;

    if (rootGetters['device/isBrowser']) {
      state.analyticsInstance.logEvent('select_promotion', {
        creative_name: creativeName,
        creative_slot: creativeSlot,
        promotion_id: contestId,
        promotion_name: contestName,
      });
    } else {
      rootState.firebase.firebasePlugin.logEvent('select_promotion', {
        creative_name: creativeName,
        creative_slot: creativeSlot,
        promotion_id: contestId,
        promotion_name: contestName,
      });
    }
  },
  // logEvent({state, commit, rootGetters}) {

  // },
  // onDeviceReadyForFirebase({ state, dispatch, commit, rootState }, { vueRouter }) {
  //   // Register handlers
  //   state.firebasePlugin.onMessageReceived((message) => {
  //     try {
  //       if (message.messageType === 'notification') {
  //         dispatch('handleNotificationMessage', { message, vueRouter });
  //       } else {
  //         // dispatch('handleDataMessage', { message });
  //       }
  //     } catch (e) {
  //       Sentry.captureMessage(`Exception in onMessageReceived callback: ${e.message}`);
  //     }
  //   }, (error) => {
  //     Sentry.captureException(error);
  //   });

  //   state.firebasePlugin.onTokenRefresh((token) => {
  //     commit('setToken', token);

  //     dispatch('syncFirebaseDetails');
  //   }, (error) => {
  //     Sentry.captureException(error);
  //   });

  //   dispatch('checkNotificationPermission', { requested: false }); // Check permission then get token

  //   if (rootState.device.platform === 'android') {
  //     dispatch('initAndroid');
  //   } else if (rootState.device.platform === 'ios') {
  //     dispatch('initIos');
  //   }

  //   dispatch('getInstallationId');
  // },
  // syncFirebaseDetails({ state, rootState, rootGetters }) {
  //   if (!rootGetters['device/isBrowser'] && rootGetters['auth/isAuthenticated']) {
  //     axiosUserInstance.post(`user-device-firebase-info/${rootState.device.uuid}`, {
  //       fcm_token: state.token,
  //       apns_token: state.APNStoken,
  //       fcm_installation_id: state.installationId,
  //     })
  //       .then()
  //       .catch((err) => {
  //         Sentry.captureException(err);
  //       });
  //   }
  // },
  // promptUserForInput(
  //   { commit },
  //   // eslint-disable-next-line camelcase
  //   { title, msg, cb },
  // ) {
  //   window.navigator.notification.prompt(
  //     msg,
  //     (result) => {
  //       const input = result.input1 || '';
  //       cb(input.trim());
  //     },
  //     title,
  //     ['Ok'],
  //   );
  // },
  // getToken({ commit, state, dispatch }) {
  //   state.firebasePlugin.getToken((token) => {
  //     commit('setToken', token);

  //     dispatch('syncFirebaseDetails');
  //   }, (error) => {
  //     Sentry.captureException(error);
  //   });
  // },
  // checkNotificationPermission({ commit, state, dispatch }, { requested }) {
  //   state.firebasePlugin.hasPermission((hasPermission) => {
  //     if (hasPermission) {
  //       // Granted
  //       dispatch('getToken');
  //     } else if (!requested) {
  //       // Request permission
  //       state.firebasePlugin.grantPermission(() => dispatch('checkNotificationPermission', { requested: true }));
  //     } else {
  //       // Denied
  //       // console.log("Notifications won't be shown as permission is denied");
  //     }
  //   });
  // },
  // handleNotificationMessage({ state }, { message, vueRouter }) {
  //   if (message.tap && message.page) {
  //     const pageToRedirect = {
  //       path: message.page,
  //       query: { },
  //     };

  //     if (message.params) {
  //       pageToRedirect.query = JSON.parse(message.params);
  //     }

  //     vueRouter.push(pageToRedirect);
  //   } else if (message.tap) {
  //     vueRouter.push('/');
  //   }
  // },
  // handleDataMessage({ state }, { message }) {
  //   console.log(`Data message received: ${JSON.stringify(message)}`);
  // },
  // initAndroid({ state }) {
  //   state.firebasePlugin.createChannel(PROMOTIONS_CHANNEL,
  //     () => { },
  //     (error) => {
  //       Sentry.captureException(error);
  //     },
  //   );

  //   state.firebasePlugin.createChannel(WINNERS_CHANNEL,
  //     () => { },
  //     (error) => {
  //       Sentry.captureException(error);
  //     },
  //   );
  // },
  // initIos({ state, commit }) {
  //   state.firebasePlugin.onApnsTokenReceived((token) => {
  //     commit('setAPNStoken', token);
  //   }, (error) => {
  //     Sentry.captureException(error);
  //   });
  // },
  // getInstallationId({ state, commit }) {
  //   state.firebasePlugin.getInstallationId((id) => {
  //     commit('setInstallationId', id);
  //   }, (error) => {
  //     Sentry.captureException(error);
  //   });
  // },
};

  // mutations
const mutations = {
  setFirebaseAnalyticsInstance(state, analyticsInstance) {
    state.analyticsInstance = analyticsInstance;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/firebaseAnalytics.js